import useAppSelector from '@/hooks/useAppSelector'
import { selectCurrentUser } from '@/redux/slices/session'
import { SessionMetadataUser } from '@/types/responses/session-metadata'

export function useCurrentUser(): SessionMetadataUser | undefined {
  return useAppSelector(selectCurrentUser)
}
